export default __webpack_public_path__ + "static/discover_2-eea3e8452f712806fa639c25bd53d661.png";